import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [filter, setFilter] = useState('open');

  async function load() {
    const r = await api.alerts({ status: filter });
    setAlerts(r.alerts);
  }
  useEffect(() => { load().catch(console.error); }, [filter]);

  async function ack(id) { await api.ackAlert(id); load(); }
  async function resolve(id) { await api.resolveAlert(id); load(); }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Alerts & Exceptions</h1>
        <div className="flex gap-2">
          {['open','acknowledged','resolved','all'].map(f => (
            <button key={f} onClick={() => setFilter(f)}
              className={`btn ${filter === f ? 'bg-brand-600 text-white' : 'bg-white border border-slate-200 text-slate-700'}`}>
              {f}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-2">
        {alerts.length === 0 && <div className="text-slate-400 text-sm">No alerts</div>}
        {alerts.map(a => (
          <div key={a.id} className="card p-4 flex items-start gap-3">
            <div className="w-1 self-stretch rounded"
                 style={{ background: a.severity === 'critical' ? '#dc2626' : a.severity === 'warning' ? '#d97706' : '#2563eb' }} />
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <div className="font-medium">{a.title}</div>
                <span className={`badge-${a.severity === 'critical' ? 'critical' : a.severity === 'warning' ? 'warning' : 'info'}`}>
                  {a.severity}
                </span>
                <span className="badge-neutral">{a.category}</span>
                <span className="badge-neutral text-xs">{a.rule_id}</span>
              </div>
              <div className="text-sm text-slate-600 mt-1">{a.message}</div>
              <div className="text-xs text-slate-500 mt-1">
                {a.first_name} {a.last_name} (MRN {a.mrn}) · {new Date(a.created_at).toLocaleString()}
              </div>
            </div>
            <div className="flex gap-1">
              {a.status === 'open' && <button onClick={() => ack(a.id)} className="btn-ghost text-xs">Ack</button>}
              {a.status !== 'resolved' && <button onClick={() => resolve(a.id)} className="btn-primary text-xs">Resolve</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
